<template>
  <div class="login-container">
    <header class="header">
      学生信息报备系统
    </header>
    <form @submit.prevent="handleSubmit" class="login-form">
      <p class="error-msg">{{msg}}</p>
      <div class="form-group">
        <label for="username" class="label">用户名:</label>
        <input type="text" id="username" v-model="username" required class="form-input" placeholder="请输入用户名">
      </div>
      <div class="form-group">
        <label for="password" class="label">密码:</label>
        <input type="password" id="password" v-model="password" required class="form-input" placeholder="请输入密码">
      </div>
      <button type="submit" class="login-button">登录</button>
    </form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      username: '',
      password: '',
      msg: ''
    };
  },
  methods: {
    handleSubmit() {
      axios.post('http://39.100.109.86:8093/user/login', {
        username: this.username,
        password: this.password
      })
          .then(response => {
            // 处理响应数据
            console.log(response.data);
            if (response.data.data !== null) {
              const status = response.data.data.status;
              const userName = response.data.data.userName;
              this.$router.push({ name: 'Show' });
              localStorage.setItem("username", JSON.stringify(userName));
              localStorage.setItem("status", JSON.stringify(status));
            } else {
              // 返回错误信息
              this.msg = response.data.msg;
            }
          })
          .catch(error => {
            // 处理错误
            console.error(error);
          });
    }
  }
};
</script>

<style scoped>
.header {
  font-size: 35px;
  text-align: left;
  font-weight: 700;
  padding: 20px;
  background-color: #0E7AC3;
  color: white;
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.login-form {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.form-group {
  width: 100%;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.label {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
  width: 100%;
  text-align: left;
}

.form-input {
  width: 100%;
  padding: 0.75rem;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 5px;
  outline: none;
  transition: border-color 0.3s ease;
}

.form-input:focus {
  border-color: #add8e6;
}

.login-button {
  width: 100%;
  padding: 0.75rem;
  font-size: 16px;
  color: white;
  background-color: #0E7AC3;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.login-button:hover {
  background-color: #0e7adf;
}

.error-msg {
  color: crimson;
  text-align: center;
  margin-bottom: 1rem;
}
</style>
